import React from 'react'

import PartnerForm from './components/PartnerForm'
import PartnerList from './components/PartnerList'

const Partner: React.FC = () => {
  return (
    <div className="row partner">
      <PartnerForm />
      <PartnerList />
    </div>
  )
}

export default Partner
